import React from "react";
import { NumericFormat } from "react-number-format";
import Field from "./Field";

interface InputProps {
  label?: React.ReactNode;
  value?: string;
  placeholder?: string;
  name: string;
  margin?: string;
  onChange: (e: any) => void;
  showIcon?: boolean;
  thousandSeparator?: boolean;
  prefix?: string;
  suffix?: string;
  svg?: React.ReactNode;
  icon?: string;
  hint?: string;
  error?: string;
  required?: boolean;
}

const Number: React.FC<InputProps> = ({
  label,
  value,
  name,
  placeholder,
  margin,
  onChange,
  showIcon = false,
  thousandSeparator = false,
  prefix = "",
  suffix = "",
  svg,
  icon = "bi-cash",
  hint = "",
  error,
  required,
}) => {
  return (
    <Field
      label={label}
      margin={margin}
      icon={showIcon && !svg ? icon : undefined}
      iconNode={showIcon ? svg : undefined}
      hint={hint}
      error={error}
      required={required}
    >
      <NumericFormat
        className="form-control"
        value={value}
        allowLeadingZeros
        valueIsNumericString
        thousandSeparator={thousandSeparator}
        placeholder={placeholder}
        prefix={prefix}
        suffix={suffix}
        onValueChange={(values) => {
          onChange({
            target: {
              name: name,
              value: values.value,
            },
          });
        }}
      />
    </Field>
  );
};

export default Number;
